function initDreamCarousels() {
    const dreamCarousels = document.querySelectorAll('.maje-dream-swiper');

    dreamCarousels.forEach(customSwiper => {
        const nextBtn = customSwiper.querySelector('.swiper-button-next');
        const prevBtn = customSwiper.querySelector('.swiper-button-prev');
        const pagination = customSwiper.querySelector('.swiper-pagination');

        
        const swiper = new Swiper(customSwiper, {
            loop: true,
            draggable: true,
            cursor: 'grab',
            slidesPerView: 1,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn,
            },
            pagination: {
                el: pagination,
            },
        });
        
        const paginationBullets = customSwiper.querySelectorAll('.swiper-pagination .swiper-pagination-bullet');
        
        paginationBullets.forEach((bullet, index) => {
            bullet.addEventListener('click', () => {
                swiper.slideTo(index);
            });
        });
        
    })
}

if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', initDreamCarousels);
}

initDreamCarousels()